import React from 'react';

import { connect } from 'react-redux';
import QRCode from 'qrcode.react';
import Cookies from 'js-cookie';

import colors from '../util/colors';
import { VERSION, getLogsFlag, setLogsFlag, fireAnalytics } from './utils';

// Actions
import { deleteDevice } from '../store/actions/deviceActions';
import { clearFeaturedPlaylist, clearUserPlaylists, clearActivePlaylist } from '../store/actions/playlistActions';
import { clearUser } from '../store/actions/userActions';
import { clearSubscription } from '../store/actions/subscriptionActions';
import { DELETE_DEVICE_SUCCESS } from '../store/constants/deviceConstants';

import { LEFT, RIGHT, BACK, ENTER } from '../util/remoteButtons';

export class Account extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      logs: getLogsFlag(),
      logsTextVisibilty: false
    }
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.selectedBtn = "Back";
    this.enableLogs = 0;
    this.logsTimeout = null;
    this.logsText = "";
  }

  componentDidMount() {
    fireAnalytics("Page", "Account Page Loaded");
    var backButton = this.refs.backButton;
    backButton.focus();
  }

  handleKeyDown(e) {
    e.stopPropagation();if(e.which === 38 || e.which === 40) {
      if(this.logsTimeout !== null) {
        clearTimeout(this.logsTimeout);
      }
      if(this.enableLogs === 76 && e.which !== 40) this.enableLogs = 0;
      this.enableLogs = this.enableLogs + e.which;
      if(this.enableLogs === 154) {
        if(this.state.logs) {
          this.logsText = "Player Logs Disabled";
          this.setState({ logsTextVisibilty: true });
            setTimeout(() => {
                this.setState({ logsTextVisibilty: false });
            }, 3000);
          setLogsFlag(false);
          this.setState({ logs: false });
        } else {
          setLogsFlag(true);
          this.setState({ logs: true });
          this.logsText = "Player Logs Enabled";
          this.setState({ logsTextVisibilty: true });
            setTimeout(() => {
                this.setState({ logsTextVisibilty: false });
            }, 3000);
        }
        this.enableLogs = 0;
      }
      this.logsTimeout = setTimeout(() => {
        this.enableLogs = 0;
      }, 7000);
    }
    else {
      this.enableLogs = 0;
    }
    switch (e.which) {
      case RIGHT:
        if (this.selectedBtn === "Back") {
          this.refs.logout.focus();
          this.selectedBtn = "Logout"
        }
        break;
      case LEFT:
        if (this.selectedBtn === "Logout") {
          this.refs.backButton.focus();
          this.selectedBtn = "Back";
        }
        break;
      case ENTER:
        if (this.selectedBtn === "Back") {
          this.props.history.goBack();
        }
        if (this.selectedBtn === "Logout") {
          fireAnalytics('User', 'Logged Out', this.props.user.data.user?.email);
          this.logout();
        }
        break;
      case 27:       /////////////////For Esc Keyboard Key
      case BACK:
        this.props.history.goBack();
        break;
    }
  }

  logout = async () => {
    try {
      const response = await this.props.deleteDevice(this.props.device.data.id);
      Cookies.remove('auth__token');
      this.props.clearFeaturedPlaylist();
      this.props.clearUserPlaylists();
      this.props.clearActivePlaylist();
      this.props.clearUser();
      this.props.clearSubscription();
      if (response.errors === "Error") {
        setTimeout(() => {
          this.props.history.push('/error');
        }, 10);
        return;
      }
      if (response.type === DELETE_DEVICE_SUCCESS) {
        this.props.history.push('/');
      }
    } catch (e) {
      console.log(e);
    }
  };

  render() {
    return (
      <div className="Wrapper">
        <div className="InfoWrapper" onKeyDown={this.handleKeyDown}>
          <img className="Logo2" src="assets/img/blackdove-logo-2020.png" alt="" />
          <span className="Info">
            Go to https://account.blackdove.com to change your account details and edit your subscription.
          </span>
          <div className="DetailsWrapper" style={{ borderTop: `1px solid ${colors.lighterBase}` }}>
            <div className="DetailLabel">Account:</div>
            <div className="DetailLabel">{this.props.user.data.user?.email}</div>
          </div>
          <div
            className="DetailsWrapper"
            style={{ borderBottom: `1px solid ${colors.lighterBase}`, marginBottom: '40px' }}
          >
            <div className="DetailLabel">Subscription:</div>
            <div className="DetailLabel">{this.props.subscription.data.plan?.description}</div>
          </div>
          <div>
            <div className="row row--push-btm-xs">
              <div className="col-5">
                <div ref="backButton" tabIndex="6" className="btn btn--round btn--block btn--dark info__btn pull-left "
                  style={{ padding: "0.7em", background: "#910048" }}
                  onClick={() => this.props.history.goBack()}>Back</div>
              </div>
              <div className="col-7">
                <div tabIndex="7"
                  ref="logout"
                  className="btn btn--round btn--dark pull-right info__btn" style={{ width: "100%", padding: "0.7em", background: "#910048" }}
                  onClick={() => this.logout()}>Logout</div>
              </div>
            </div>
          </div>
        </div>
        <div className="QRWrapper">
          <QRCode value={this.props.app.SSSPDeviceId} size={200} renderAs="svg" />
        </div>
        <div className="VersionWrapper">
          {`v ${VERSION}`}
        </div>
        <div className="timedPopup" style={!this.state.logsTextVisibilty ? { opacity: '0' } : { opacity: '1' }} >{this.logsText}</div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  deleteDevice: (deviceId) => dispatch(deleteDevice(deviceId)),
  clearFeaturedPlaylist: () => dispatch(clearFeaturedPlaylist()),
  clearUserPlaylists: () => dispatch(clearUserPlaylists()),
  clearActivePlaylist: () => dispatch(clearActivePlaylist()),
  clearUser: () => dispatch(clearUser()),
  clearSubscription: () => dispatch(clearSubscription()),
});

export default connect((state) => {
  const { app, activePlaylist, device, user, subscription } = state;
  return {
    app,
    device,
    user,
    subscription,
    activePlaylist,
  };
}, mapDispatchToProps)(Account);
